import InputField from '@cube3/cubicle/src/core/atoms/InputField/InputField';
import React from 'react';
import { getErrorMessage, getReadableErrors } from '../utils/getErrorMessage';
import { FieldWithState } from '../types/GenericFormTypes';

export interface TextFieldProps {
  minLength?: number;
  maxLength?: number;
  multiline?: number;
  fullWidth?: boolean;
  width?: number | string;
  autoComplete?: string;
  pattern?: string;
}

type Props = FieldWithState<string, 'string'>;

export const TextField = (props: Props) => {
  const {
    // field props
    showErrors,
    //input
    //meta
    error,
    touched,
    invalid,
    active,
    warning,
    // own props
    fullWidth,
    width,
    autoComplete,

    ...restProps
  } = props;

  const messages = error
    ? getErrorMessage(error)
    : warning
    ? getReadableErrors(warning)
    : '';

  const shouldError =
    showErrors != null ? showErrors : touched && !active && invalid;

  return (
    <InputField
      {...restProps}
      width={fullWidth ? '100%' : width}
      messageLabel={messages}
      showMessage={!!warning?.length || shouldError}
      criticalState={shouldError && !!error}
      messageColor={error ? 'critical' : warning ? 'warning' : 'default'}
      autoFill={!!autoComplete}
      autoComplete={autoComplete}
    />
  );
};
